<mat-progress-spinner
  mode="indeterminate"
  color="primary"></mat-progress-spinner>
